export default __webpack_public_path__ + "static/media/architecture.9f30edfd.jpg";